import styled from "styled-components";

export const DocumentsContentWrapperScrollbar = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: calc(100vh - 490px);
    & >div {
        padding: 0px;
    }
`;
export const DocumentsContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding-right: 8px;
    gap: 16px;
    & >div {
        width: 100%;
    }

`;

export const AccessOptionsBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const AccessOptionsBarLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap:16px;
`;
export const AccessOptionsBarRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

export const CustomModalContentContainer = styled.div`
	display: flex;
	max-height: 72px;
    min-height: 30px;
	overflow-y: auto;
	padding-right:	8px;
	flex-wrap: wrap;
	justify-content: center;
	gap:24px;

  &::-webkit-scrollbar {
      width: 6px;
  }

  &::-webkit-scrollbar-track {
      background: ${props => props.theme.colors.highClearGray};
  }

  &::-webkit-scrollbar-thumb {
      background: ${props => props.theme.colors.lighterGray};
      border-radius: 3px;
  }
`

export const DocumentDetailWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	gap: 4px;
    align-items: center;
    
    & > span:nth-child(2){
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 120px;
        display: block;
    }
`